/* MAOMAO · Wishlist-King-ATC-Angleichung (QA1, 260708)
   Problem: Der „In den Einkaufswagen legen“-Button auf /apps/wishlist ist ein normales
   Form-POST auf /cart/add → harter Redirect zur /cart-Seite, kein Toast, keine Events
   (Pfand-/TK-Gebuehren-Logik in custom.js wurde uebersprungen).
   Fix: Submit/Klick abfangen → AJAX /cart/add.js → gruener Toast + dieselben Events
   wie Kachel/PDP (cart:change, cart:refresh, ajaxProduct:added).
   Zusatz: Button-Wording vereinheitlicht („In den Warenkorb“, wie im Rest des Shops). */
(function(){
  'use strict';
  var BUSY='Wird hinzugefügt …';
  function toastEl(){
    var t=document.getElementById('mmToast');
    if(!t){
      t=document.createElement('div');
      t.id='mmToast';t.className='mm-toast';
      t.style.cssText='position:fixed;left:50%;transform:translateX(-50%) translateY(14px);bottom:96px;background:#1E7A52;color:#fff;font-weight:700;font-size:13.5px;padding:12px 20px;border-radius:12px;box-shadow:0 12px 30px -8px rgba(0,0,0,.35);opacity:0;pointer-events:none;transition:opacity .2s, transform .2s;z-index:10080;max-width:88vw;text-align:center';
      document.body.appendChild(t);
    }
    return t;
  }
  function toast(msg){
    var t=toastEl();
    t.textContent=msg;
    t.style.opacity='1';t.style.transform='translateX(-50%) translateY(0)';
    clearTimeout(window.__mmWkToastT);
    window.__mmWkToastT=setTimeout(function(){t.style.opacity='0';t.style.transform='translateX(-50%) translateY(14px)';},2200);
  }
  function addViaAjax(form){
    var idEl=form.querySelector('[name="id"]');
    if(!idEl)return false;
    var qEl=form.querySelector('[name="quantity"]');
    var btn=form.querySelector('button[type="submit"],button.wk-cta-button,button');
    var old=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent=BUSY;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(idEl.value,10),quantity:parseInt(qEl&&qEl.value,10)||1}]})})
      .then(function(r){return r.json().then(function(body){return {ok:r.ok,body:body}})})
      .then(function(x){
        if(btn){btn.disabled=false;btn.textContent=old;}
        if(!x.ok){toast((x.body&&(x.body.description||x.body.message))||'Fehler beim Hinzufügen');return;}
        toast('✓ Erfolgreich in den Warenkorb gelegt');
        document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(function(){if(btn){btn.disabled=false;btn.textContent=old;}toast('Fehler beim Hinzufügen');});
    return true;
  }
  function isWkAddForm(el){
    return el && el.matches && el.matches('form.wk-form[action*="/cart/add"]');
  }
  /* Submit-Weg (Button type=submit) */
  document.addEventListener('submit',function(e){
    if(!isWkAddForm(e.target))return;
    if(addViaAjax(e.target)){e.preventDefault();e.stopPropagation();}
  },true);
  /* Klick-Weg (falls Wishlist King programmatisch submitted — form.submit() feuert kein submit-Event) */
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('form.wk-form[action*="/cart/add"] button');
    if(!btn)return;
    var form=btn.closest('form');
    if(addViaAjax(form)){e.preventDefault();e.stopPropagation();}
  },true);
  /* Wording: „In den Einkaufswagen legen“ → „In den Warenkorb“ (WK rendert per Lit nach — daher beobachten) */
  function relabel(){
    document.querySelectorAll('.wk-cta-button').forEach(function(b){
      if(b.disabled||b.textContent===BUSY)return;
      if(/einkaufswagen/i.test(b.textContent))b.textContent='In den Warenkorb';
    });
  }
  if(/\/apps\/wishlist/.test(location.pathname)){
    relabel();
    document.addEventListener('DOMContentLoaded',relabel);
    new MutationObserver(function(){relabel();}).observe(document.body||document.documentElement,{childList:true,subtree:true});
  }
})();
